import type { JSX } from 'react';
import type { TranslationKeys } from '../../i18n/types.js';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

export interface SecondUseDialogProps {
  readonly open: boolean;
  /** «<name>» лежит в бите «…». */
  readonly title: string;
  readonly t: (key: keyof TranslationKeys) => string;
  /** «В общий список и добавить». */
  readonly onShare: () => void;
  /** «Добавить, оставить где есть». */
  readonly onKeep: () => void;
  /** «Отмена» (also Escape). */
  readonly onCancel: () => void;
}

/**
 * P03 (Q-2): a note that lives in one beat / objective is about to be used in a
 * second place. Studio asks — never moves it by itself: to the shared list and
 * add, add and leave it where it is, or cancel.
 */
export function SecondUseDialog({ open, title, t, onShare, onKeep, onCancel }: SecondUseDialogProps): JSX.Element {
  return (
    <AlertDialog open={open} onOpenChange={(next: boolean): void => { if (!next) onCancel(); }}>
      <AlertDialogContent data-testid="second-use-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{t('studio.owner.secondUseBody')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="second-use-cancel" onClick={onCancel}>{t('studio.owner.secondUseCancel')}</AlertDialogCancel>
          <AlertDialogAction data-testid="second-use-keep" onClick={onKeep}>{t('studio.owner.secondUseKeep')}</AlertDialogAction>
          <AlertDialogAction data-testid="second-use-share" onClick={onShare}>{t('studio.owner.secondUseShare')}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
